import { Col, Label, ReactSelectBox } from "client/CommonComponents";

const UtilityVehicle = (props?: any) => {
 const managedEquipmentValues = props?.managedEquipmentValues;
 const manufacturerDropDownList = props?.manufacturerDropDownList;
 const seatingCapacityDropDownList = props?.seatingCapacityDropDownList;
 const enclosedCabDropDownList = props?.enclosedCabDropDownList;
 const capacityDropDownList = props?.capacityDropDownList;
 const managedEquipRef = props?.managedEquipRef;
 const handleSeatingCapacityChange = props?.handleSeatingCapacityChange;
 const handleManufacturerChange = props?.handleManufacturerChange;
 const handleEnclosedCabChange = props?.handleEnclosedCabChange;
 const handleCapacityChange = props?.handleCapacityChange;

  return (<>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="UtilityVehicle_Default_Label_4">Seating Capacity</Label>
        <ReactSelectBox
          options={seatingCapacityDropDownList}
          onChange={(item: any, e: any) => handleSeatingCapacityChange(e, item,'seatingCapacity')}
          value={managedEquipmentValues?.seatingCapacity}
          selectRef={(element:any)=> managedEquipRef.current[1] = element}
         data-attribute="UtilityVehicle_Default_SearchSelectBox_4" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="UtilityVehicle_Default_Label_2_2">Manufacturer</Label>
        <ReactSelectBox
          options={manufacturerDropDownList}
          onChange={(item: any, e: any) => handleManufacturerChange(e, item,'manufacturer')}
          value={managedEquipmentValues?.manufacturer}
          selectRef={(element:any)=> managedEquipRef.current[2] = element}
         data-attribute="UtilityVehicle_Default_SearchSelectBox_5" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label data-attribute="UtilityVehicle_Default_Label_3_2">Enclosed Cab</Label>
          <ReactSelectBox
            options={enclosedCabDropDownList}
            onChange={(item: any, e: any) => handleEnclosedCabChange(e, item,'enclosedCab')}
            value={managedEquipmentValues?.enclosedCab}
            selectRef={(element:any)=> managedEquipRef.current[3] = element}
           data-attribute="UtilityVehicle_Default_SearchSelectBox_6" />
        </Col>
        <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label data-attribute="UtilityVehicle_Default_Label_4_2">Capacity</Label>
          <ReactSelectBox
            options={capacityDropDownList}
            onChange={(item: any, e: any) => handleCapacityChange(e, item,'capacity')}
            value={managedEquipmentValues?.capacity}
            selectRef={(element:any)=> managedEquipRef.current[4] = element}
           data-attribute="UtilityVehicle_Default_SearchSelectBox_7" />
        </Col>
  </>)
}

export default UtilityVehicle;
